<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">C<span class="smallcaps">ONTENTS</span></h1>
<p class="toc-fm"><a href="#/007_Foreword#fm-1"><em>Foreword</em> by Sara Wilhelm Garbers</a></p>
<p class="toc-fm"><a href="#/008_Preface#fm-2"><em>Preface</em></a></p>
<p class="toc-fm"><a href="#/009_Ack#fm-3"><em>Acknowledgments</em></a></p>
<p class="toc-fm1"><a href="#/010_Introduction#fm-4">Introduction</a></p>
<p class="toc-chap"><a href="#/011_Chapter01#ch-1"><span class="pad">1.</span> “YHWH Has Become King”</a></p>
<p class="toc-chap"><span href="#/012_Chapter02#ch-2" title="Link target outside of Sample"><span class="pad">2.</span> The Hopes of the Prophets</span></p>
<p class="toc-chap"><span href="#/013_Chapter03#ch-3" title="Link target outside of Sample"><span class="pad">3.</span> The Day of YHWH’s Apocalypse</span></p>
<p class="toc-chap"><span href="#/014_Chapter04#ch-4" title="Link target outside of Sample"><span class="pad">4.</span> “The Kingdom of God Is in Your Midst”</span></p>
<p class="toc-chap"><span href="#/015_Chapter05#ch-5" title="Link target outside of Sample"><span class="pad">5.</span> The Way of the Kingdom</span></p>
<p class="toc-chap"><span href="#/016_Chapter06#ch-6" title="Link target outside of Sample"><span class="pad">6.</span> “Thy Kingdom Come!”</span></p>
<p class="toc-bm1"><span href="#/017_Conclusion#bm-1" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-bm"><span href="#/018_Bibliography#bm-2" title="Link target outside of Sample"><em>Bibliography</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Contents.vue?f433235c